import { render } from "./ContactForm.vue?vue&type=template&id=6b0f4598&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=6b0f4598&scoped=true&lang=css"

import exportComponent from "/home/dre/personalsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0f4598"]])

export default __exports__